import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeModal()))
  }, [
    _createVNode(_component_fa, {
      icon: "envelope",
      class: "text-xl"
    }),
    _createElementVNode("span", {
      class: _normalizeClass([[$setup.state.notifications > 0 ? 'text-sirit_blue-500 font-bold' : '' ], "text-md t-50"])
    }, " (" + _toDisplayString($setup.state.notifications) + ")", 3)
  ]))
}